import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import ActionWithSymbol from '../actionWithSymbol/actionWithSymbol';
import CalendarSymbol from '../icons/calendar.svg.js';
import dateUtil from '../../util/date';
import DatePicker from '../datePicker/datePicker';
import ContextMenu from '../contextMenu/contextMenu';

var DatePickerInput = /*#__PURE__*/function (_React$Component) {
  _inherits(DatePickerInput, _React$Component);

  var _super = _createSuper(DatePickerInput);

  function DatePickerInput(props) {
    var _this;

    _classCallCheck(this, DatePickerInput);

    _this = _super.call(this, props);

    _this.getCustomButton = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          translateIfNeeded = _this$props.translateIfNeeded,
          placeholder = _this$props.placeholder,
          removeIcon = _this$props.removeIcon;
      var isValidDate = dateUtil.isValid(value);
      var children = isValidDate ? value.toLocaleDateString() : translateIfNeeded(placeholder);
      return /*#__PURE__*/React.createElement(ActionWithSymbol, {
        initialized: isValidDate,
        symbol: removeIcon ? false : /*#__PURE__*/React.createElement(CalendarSymbol, null)
      }, children);
    };

    return _this;
  }

  _createClass(DatePickerInput, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.getClassName('control-date-picker-input'),
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook
      }, /*#__PURE__*/React.createElement(ContextMenu, {
        className: "context-menu-block",
        alignment: "BOTTOM",
        direction: "MIDDLE",
        customButton: this.getCustomButton()
      }, /*#__PURE__*/React.createElement(DatePicker, {
        value: this.props.value,
        onChange: this.props.onChange,
        validateDate: this.props.validateDate
      })));
    }
  }]);

  return DatePickerInput;
}(React.Component);

DatePickerInput.displayName = 'DatePickerInput';
DatePickerInput.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,

  /** Placeholder to show when no date is selected */
  placeholder: PropTypes.string.isRequired,

  /** On date change callback */
  onChange: PropTypes.func.isRequired,

  /** Date value */
  value: PropTypes.object,

  /** */
  removeIcon: PropTypes.bool,

  /** A predicate function to decide what dates are accepted. */
  validateDate: PropTypes.func
};
DatePickerInput.defaultProps = {
  removeIcon: false
};
export default compose(DatePickerInput);